export default __webpack_public_path__ + "img/e4d8f92006417d73d281894eea59bb1d.svg";